import { AuthService as EsAuthService, AuthUtil } from '@examsoft/es-login';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, Observer, BehaviorSubject } from 'rxjs';
import {Location} from '@angular/common';


interface IApp{
  institutionName?: string;
  type?: string;
  user?: string;
  fullName?: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {

  app$: BehaviorSubject<IApp|false> = new BehaviorSubject(false);

  constructor(
    private util: AuthUtil,
    private location: Location,
    private authUtil: AuthUtil,
    private esAuth: EsAuthService,
    private http: HttpClient
  ) {
    this.esAuth.user$.subscribe(data => {
      if(data){
        this.app$.next(this.setup(data));
      }
    });
  }

  get(){
    return this.app$;
  }

  public isAdmin(info){
    return info && info.username.match(/examsoft\.com|codehaus\.es|examsofttest\.com|softtek\.com/i)
  }

  private setup(info){
    return {
      type:  this.isAdmin(info) ? 'internal' : 'external',
      role: info.role,
      user: info.email,
      fullName: info.fullName,
      portal: info.username.match(/phx/) ? 'phx' : 'leg'
    };
  }

  public allowed(){
    let school = this.util.getProvider();
    let user = this.esAuth.user;
    let url = this.location.path();

    if( !this.isAdmin(user) && !url.match(school.uuid) ){
      window.location.href = `/${school.uuid}/exam-monitor/summary`;
    }
  }
}
